import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "license-widget-wrapper h-full w-full column inline no-wrap min-w-[450px] flex" }

import LicenseLayout from '@/views/license/licenserComponents/layout/license-layout.vue';
import IbOkCancelDialog from '@/components/common/dialogs/OkCancelDialog.vue';
import LicenseTier from '@/views/license/licenserComponents/licenseTier.vue';
import LicenseDeactivate from '@/views/license/licenserComponents/licenseDeactivate.vue';
import LicenseInfoLinux from '@/views/license/OS/licenseComponentsLinux/licenseInfo.linux.vue';
import { inject, computed, reactive } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useLicense_Action_Deactivate_AsyncMutation, useLicensePageQuery } from '@/graphql/codegen/generated/graphql';
import { longPolling } from '@/services/PlatfromGQL/longPolling';
import { useRouter } from 'vue-router';
import LicenseUsage from '@/views/license/OS/licenseComponentsLinux/licenseUsage.vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';


export default /*#__PURE__*/_defineComponent({
  __name: 'license.linux',
  setup(__props) {

const coordinatorsService = inject(IKCoordinatorsService);
const router = useRouter();
const userRolePermissions = useUserRolePermissions();
const GQL_useLicenseInfoQuery = useLicensePageQuery(() => ({
  coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
}));
const GQL_deactivateLicense = useLicense_Action_Deactivate_AsyncMutation({});

const data = reactive({
  deactivateDialogIsOpen: false,
  deactivationFailedIsOpen: false,
});

const licenseInfo = computed(() => GQL_useLicenseInfoQuery?.result?.value?.ibManagerEntities?.license);

const deactivateLicense = () => {
  data.deactivateDialogIsOpen = true;
};

const deactivateLicenseConfirmed = async () => {
  try {
    data.deactivateDialogIsOpen = false;
    const refreshLicensePollingId = await GQL_deactivateLicense.mutate({ licenseKey: licenseInfo.value?.key || '' });
    await longPolling.fetch('license_action_asyncResult', refreshLicensePollingId?.data?.license_action_deactivate_async).then(async resultData => {
      const result = resultData?.data?.license_action_asyncResult?.result;
      if (result?.errorCode === 0 && result?.state === 0) {
        // Need to verify the state
        await router.push({ name: 'enterLicense' });
      } else {
        data.deactivationFailedIsOpen = true;
      }
    });
  } catch (error) {
    data.deactivationFailedIsOpen = true;
  }
};
const contactSupport = () => {
  data.deactivationFailedIsOpen = false;
  const supportMailUrl = process.env.VUE_APP_SUPPORT_MAIL;
  window.open(supportMailUrl, '_blank');
};
const deactivateLicenseCanceled = () => {
  data.deactivateDialogIsOpen = false;
};
const deactivateLicenseFailureCanceled = () => {
  data.deactivationFailedIsOpen = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LicenseLayout, null, {
      sideView: _withCtx(() => [
        _createVNode(LicenseTier),
        _createVNode(LicenseInfoLinux, { "license-info": _unref(licenseInfo) }, null, 8, ["license-info"]),
        (_unref(userRolePermissions).authorize?.value?.license.visible.deactivateLicense)
          ? (_openBlock(), _createBlock(LicenseDeactivate, {
              key: 0,
              onDeactivate: _cache[0] || (_cache[0] = ($event: any) => (deactivateLicense())),
              "is-unix": true
            }))
          : _createCommentVNode("", true)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(LicenseUsage, {
            licenseDetails: _unref(licenseInfo)?.linux?.licenseDetails || []
          }, null, 8, ["licenseDetails"])
        ])
      ]),
      _: 1
    }),
    _createVNode(IbOkCancelDialog, {
      value: data.deactivateDialogIsOpen,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((data.deactivateDialogIsOpen) = $event)),
      "dialog-title": _ctx.$t('license.dialog.deactivate.title'),
      body: _ctx.$t('license.dialog.deactivate.body'),
      "checkbox-verify-text": _ctx.$t('license.dialog.deactivate.verifyText'),
      "body-icon": "warning",
      "dialog-style": "warning",
      "ok-label": _ctx.$t('license.dialog.deactivate.okLabel'),
      onOk: _cache[2] || (_cache[2] = ($event: any) => (deactivateLicenseConfirmed())),
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (deactivateLicenseCanceled())),
      onHide: _cache[4] || (_cache[4] = ($event: any) => (deactivateLicenseCanceled()))
    }, null, 8, ["value", "dialog-title", "body", "checkbox-verify-text", "ok-label"]),
    _createVNode(IbOkCancelDialog, {
      value: data.deactivationFailedIsOpen,
      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((data.deactivationFailedIsOpen) = $event)),
      "dialog-title": _ctx.$t('license.dialog.deactivationFailed.title'),
      body: _ctx.$t('license.dialog.deactivationFailed.body'),
      "dialog-style": "danger",
      "button-style": "failure",
      "ok-label": _ctx.$t('license.dialog.deactivationFailed.okLabel'),
      "cancel-label": _ctx.$t('license.dialog.deactivationFailed.cancelLabel'),
      onOk: _cache[6] || (_cache[6] = ($event: any) => (contactSupport())),
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (deactivateLicenseFailureCanceled())),
      onHide: _cache[8] || (_cache[8] = ($event: any) => (deactivateLicenseFailureCanceled()))
    }, null, 8, ["value", "dialog-title", "body", "ok-label", "cancel-label"])
  ], 64))
}
}

})